<template>

  <div style="position: fixed;
  top:0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);" @click="closeView">
    <div style="position: absolute; width: 90%; height: 95%; top:50%; left:50%; transform: translate(-50%, -50%); background-color: white; border-radius: 10px; box-shadow: 5px 5px 20px black;display: flex;" v-on:click.stop="dummy">
      <div style="width:calc(100% - 500px); height:100%; padding-top:10px;" v-if="item.url !== undefined && item.url !== null && item.url.length > 0">
        <embed :src="item.url" style="width: 90%; height: calc(100% - 20px); margin:auto"/>
      </div>
      <div style="width:calc(100% - 500px); height:100%; padding-top:10px;" v-else-if="item.content !== undefined && item.content !== null && item.content.length > 0">
        <iframe :src="item.content" style="width: 90%; height: calc(100% - 20px); margin:auto"/>
      </div>
      <div style="width:500px; height:100%; padding:20px; text-align: left;">

        <div style="width: 100%; height: calc(100% - 70px); overflow-y: scroll;">
          <h3>{{item.title}}</h3>
          <h4>Email Form</h4>
          <div class="container text-left" style="padding:0;" v-if="item.emailForm !== undefined && item.emailForm !== null">
            <div class="row">
              <div class="col-12">Email (2명이상이면 ,(콤마)로 구분)
                <input v-model="item.emailForm.to" class="form-control"/>
              </div>
            </div>
            <div class="row">
              <div class="col-12" style="margin-top:20px;">
                이메일 제목:
                <input class="form-control" v-model="item.emailForm.subject"/>
              </div>
              <div class="col-12" style="margin-top:20px;">
                이메일 내용:
                <textarea class="form-control" v-model="item.emailForm.body" rows="5"/>
              </div>
              <div class="col-12" style="margin-top:20px;">
                첨부문서
                <div style="width: 100%; min-height: 50px; padding:10px; display: inline-block; border-radius: 10px; border: 1px solid grey;">
                  <div style="padding:5px; border: 1px solid grey; float:left; margin-right:10px;" v-for="(doc, di) in item.emailForm.documents">{{doc.title}} <span v-on:click="item.emailForm.documents = []"><i class="fas fa-trash"></i></span></div>
                </div>
              </div>
<!--              <div class="col-6" style="margin-top:20px;">-->
<!--                문서리스트 (첨부할 문서를 선택해주세요)-->
<!--                <div style="width: 100%; padding:10px; display: inline-block; border-radius: 10px; border: 1px solid grey;">-->
<!--                  <div style="padding:5px; border: 1px solid grey; float:left; margin-right:10px; margin-bottom: 10px;" v-for="(doc, di) in documents" v-on:click="addEmailDocItem(doc)">{{doc.title}}</div>-->
<!--                </div>-->
<!--              </div>-->


            </div>
          </div>
        </div>
        <div style="width: 100%; height: 70px;">
          <div class="container">
            <div class="row">
              <div class="col-4 text-left">
                <button class="btn btn-dark" @click="closeView">Close</button>
              </div>
              <div class="col-4 text-center">
                <button class="btn btn-primary" v-if="item.regenerateFn !== undefined && item.regenerateFn !== null" @click="regenerate">다시 생성</button>
              </div>
              <div class="col-4 text-right">
                <button class="btn btn-danger" @click="sendEmail">Send Email</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {sendEmailToCustomer} from "../api/request";
import {millisToDate, showDialog} from "../api/utils";

export default {
  name: "PdfViewer",
  props: {
    item: {
      type:Object,
      default:function(){return null}
    },
    emailForm: {
      type:Object,
      default:function(){return null}
    },
    onClose:{
      type:Function,
      default: null,
    },
  },
  created() {
    console.log("PDF viewer");
    console.log(this.item);
    this.convertBlob();
  },
  mounted() {

  },
  methods: {
    closeView: function() {
      if(this.onClose !== null) {
        this.onClose();
      }
    },
    dummy: function() {

    },
    convertBlob: function() {
      console.log("convertBlob");
      if(this.item.blob !== undefined && this.item.blob !== null && this.item.blob.size > 0) {
        console.log("convert blob to base64");
        let self = this;
        let reader = new FileReader();
        reader.readAsDataURL(this.item.blob);
        reader.onloadend = function() {
          let base64data = reader.result;
          console.log(base64data);

          self.item.content = base64data;


        }
      }
    },
    sendEmail: function() {
      let self = this;
      this.$modal.show('dialog', {
        //title: '로그아웃',
        text: this.item.emailForm.to + '에게 업데이트 이메일을 보내시겠습니까?',
        buttons: [
          {
            title: '아니요',
            handler: () => {
              self.$modal.hide('dialog');

            }
          },
          {
            title: '보내기',
            handler: () => {
              self.$modal.hide('dialog');

              self.sendEmailConfirmed();
            }
          },

        ]

      });
    },
    sendEmailConfirmed: function() {
      let self = this;
      let item = JSON.parse(JSON.stringify(this.item.emailForm));
      item.body = item.body.replaceAll('\n', "<br/>");
      sendEmailToCustomer(item)
        .then(function(data) {
          showDialog(data.message);
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    },
    regenerate: function() {
      if(this.item.regenerateFn !== undefined && this.item.regenerateFn !== null) {
        this.item.regenerateFn();
        return;
      }
    },
    b64toBlob: function(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PdfViewer.vue